import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Axios from "axios";
import PrivateRouter from "./components/utils/PrivateRouter.js";
import Main from "./components/Main.js";
import Login from './components/login/Login.js'
import auth from "./components/login/Auth.js";

export default function App() {
  
  const loadToken = () => {
	Axios.interceptors.response.use((response) => {
	   return response
	}, function (error) {
	   const originalRequest = error.config;
	   console.log(error);
	   if (error.response.status === 401 && !originalRequest._retry) {
		   originalRequest._retry = true;
		   return Axios.post('https://si.isistan.unicen.edu.ar/asistan/api/auth/refresh', {
			 
		   }).then(response => {
			   if (response.status === 200) {
					Axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
					auth.login(response.data);
					localStorage.setItem("auth", JSON.stringify(auth));
					return Axios(originalRequest);
			   }
		   });
	   }
	});
    let user = JSON.parse(localStorage.getItem("auth"));
    if (user != null && user.authenticated)
		Axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
   
  };

  loadToken();

  return (
    <div className="App">
		<div className="app-routes">
		  <BrowserRouter>
			<Switch>
			  <Route exact path="/login" component={Login} />
			  <PrivateRouter path="/" component={Main} />
			</Switch>
		  </BrowserRouter>
		</div>
	</div>
  );
}